(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const modal = document.querySelector('[data-mb-modal]');
    if (!modal) return;

    const state = {
      currentProduct: null,
      selectedSize: null,
      selectedComfort: null, // “comfort” is our generic secondary selection label
      selectedVariant: null
    };

    // Feel descriptors for Comfort options
    const COMFORT_FEEL_MAP = {
      'Duo Latex': 'Cushion-Firm Feel',
      'Duo Latex Plus': 'Medium Feel',
      'Duo Memory': 'Cushion-Firm Feel',
      'Duo Memory Plus': 'Medium-Plush Feel',
      'Duo Lift': 'Cushion-Firm Feel',
      // generic labels (some products may use these shorter names)
      'Latex': 'Cushion-Firm Feel',
      'Latex Plus': 'Medium Feel',
      'Memory': 'Cushion-Firm Feel',
      'Memory Plus': 'Medium-Plush Feel'
    };

    // DOM Elements
    const closeButton = modal.querySelector('[data-modal-close]');
    const addToCartButton = modal.querySelector('[data-modal-add-to-cart]');

    const elements = {
      image: modal.querySelector('[data-modal-image]'),
      badge: modal.querySelector('[data-modal-badge]'),
      title: modal.querySelector('[data-modal-title]'),
      subtitle: modal.querySelector('[data-modal-subtitle] .mb-modal__subtitle-text'),
      productLink: modal.querySelector('[data-modal-product-link]'),
      stars: modal.querySelector('[data-modal-stars]'),
      ratingText: modal.querySelector('[data-modal-rating-text]'),
      featuresList: modal.querySelector('[data-modal-features-list]'),
      specsList: modal.querySelector('[data-modal-specs-list]'),
      
      // Size selection (ALWAYS SHOWN FIRST)
      sizeSection: modal.querySelector('[data-modal-size-section]'),
      sizeGrid: modal.querySelector('[data-modal-size-grid]'),
      
      // Comfort/Secondary selection (OPTIONAL)
      comfortSection: modal.querySelector('[data-modal-comfort-section]'),
      comfortGrid: modal.querySelector('[data-modal-comfort-grid]'),
      
      summarySelection: modal.querySelector('[data-modal-summary-selection]'),
      summaryTotal: modal.querySelector('[data-modal-summary-total]')
    };

    setupEventListeners();

    function setupEventListeners() {
      document.addEventListener('mattress:selected', handleMattressSelected);
      closeButton.addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('mb-modal--active')) {
          closeModal();
        }
      });
      addToCartButton.addEventListener('click', handleAddToCart);
    }

    function handleMattressSelected(event) {
      const { card } = event.detail;
      const productData = extractProductData(card);
      state.currentProduct = productData;

      populateModal(productData);
      populateSizes();
      populateComforts(); // may hide itself
      resetSelection();
      openModal();
    }

    // ----------- name-aware option mapping -----------
    function extractProductData(card) {
      const optionNames = [
        (card.dataset.option1Name || '').toLowerCase(),
        (card.dataset.option2Name || '').toLowerCase(),
        (card.dataset.option3Name || '').toLowerCase()
      ];

      const data = {
        id: card.dataset.productId,
        title: card.querySelector('.mb-selector__card-title')?.textContent.trim() || '',
        description: card.querySelector('.mb-selector__card-description')?.textContent.trim() || '',
        badge: card.querySelector('.mb-selector__badge')?.textContent.trim() || '',
        rating: 0,
        image: card.dataset.productImage || card.querySelector('.mb-selector__card-image')?.src || '',
        modalImage: card.dataset.productModalImage || '',
        productUrl: card.querySelector('.mb-selector__product-url')?.textContent.trim() || '',
        features: [],
        variants: [],
        sizes: [],
        comforts: [],         // values for the chosen secondary option
        specifications: [],
        secondaryOptionKey: null // 'comfort' | 'firmness' | 'mattress' | null
      };

      // rating
      const ratingText = card.querySelector('.mb-selector__rating-text')?.textContent;
      if (ratingText) {
        const match = ratingText.match(/\((\d+\.?\d*)/);
        if (match) data.rating = parseFloat(match[1]);
      }

      // features
      card.querySelectorAll('.mb-selector__feature').forEach(feature => {
        data.features.push(feature.textContent.trim());
      });

      // specs
      const specsElement = card.querySelector('.mb-selector__specs');
      if (specsElement) {
        specsElement.querySelectorAll('.mb-selector__spec-item').forEach(item => {
          const spec = item.textContent.trim();
          if (spec) data.specifications.push(spec);
        });
      }

      // helper to map option name -> semantic field
      function mapOption(name, value, out) {
        if (!name || !value) return;
        if (name.includes('size')) out.size = value;
        else if (name.includes('comfort') || name.includes('feel')) out.comfort = value;
        else if (name.includes('firm')) out.firmness = value;
        else if (name.includes('mattress') || name.includes('model')) out.mattress = value;
      }

      // collect variants
      card.querySelectorAll('.mb-selector__variant').forEach(variant => {
        const v = {
          id: variant.dataset.variantId,
          price: variant.dataset.price,
          priceCents: parseInt(variant.dataset.priceCents || '0', 10),
          available: variant.dataset.available === 'true',
          size: null, comfort: null, firmness: null, mattress: null
        };

        mapOption(optionNames[0], variant.dataset.option1 || null, v);
        mapOption(optionNames[1], variant.dataset.option2 || null, v);
        mapOption(optionNames[2], variant.dataset.option3 || null, v);

        data.variants.push(v);
        if (v.size && !data.sizes.includes(v.size)) data.sizes.push(v.size);
      });

      // decide which non-size option we should show as secondary
      const uniques = (arr) => [...new Set(arr.filter(Boolean))];
      const comfortVals  = uniques(data.variants.map(v => v.comfort));
      const firmnessVals = uniques(data.variants.map(v => v.firmness));
      const mattressVals = uniques(data.variants.map(v => v.mattress));

      if (comfortVals.length > 1)      { data.secondaryOptionKey = 'comfort';  data.comforts = comfortVals; }
      else if (firmnessVals.length > 1){ data.secondaryOptionKey = 'firmness'; data.comforts = firmnessVals; }
      else if (mattressVals.length > 1){ data.secondaryOptionKey = 'mattress'; data.comforts = mattressVals; }
      else                             { data.secondaryOptionKey = null;        data.comforts = []; }

      return data;
    }
    // ------------------------------------------------------

    function populateModal(data) {
      // Image
      if (elements.image) {
        const imageToUse = data.modalImage || data.image;
        if (imageToUse) {
          elements.image.src = imageToUse;
          elements.image.alt = data.title;
        }
      }

      // Badge
      if (data.badge && elements.badge) {
        elements.badge.textContent = data.badge;
        elements.badge.style.display = 'inline-block';
      } else if (elements.badge) {
        elements.badge.style.display = 'none';
      }

      // Title & Subtitle
      if (elements.title) elements.title.textContent = data.title;
      if (elements.subtitle) elements.subtitle.textContent = data.description;

      // Product Link
      if (elements.productLink && data.productUrl) {
        elements.productLink.href = data.productUrl;
        elements.productLink.style.display = 'inline-flex';
      } else if (elements.productLink) {
        elements.productLink.style.display = 'none';
      }

      // Rating
      if (data.rating && elements.stars) {
        elements.stars.innerHTML = generateStars(data.rating);
        elements.ratingText.textContent = `(${data.rating}/5)`;
      }

      // Features
      if (data.features.length && elements.featuresList) {
        elements.featuresList.innerHTML = '';
        data.features.forEach(feature => {
          const li = document.createElement('li');
          li.textContent = feature;
          elements.featuresList.appendChild(li);
        });
      }

      // Specifications
      if (elements.specsList) {
        if (data.specifications && data.specifications.length > 0) {
          elements.specsList.innerHTML = '';
          data.specifications.forEach(spec => {
            const li = document.createElement('li');
            li.textContent = spec;
            elements.specsList.appendChild(li);
          });
        } else {
          elements.specsList.innerHTML = `
            <li>Height: 10 inches</li>
            <li>Firmness: Medium</li>
            <li>Materials: High-density foam</li>
            <li>Cover: Polyester blend</li>
            <li>Weight: Varies by size</li>
          `;
        }
      }

      // Update the secondary heading label once
      const heading = elements.comfortSection?.querySelector('h4');
      if (heading) {
        const key = data.secondaryOptionKey;
        const label = key === 'firmness' ? 'Firmness' : (key === 'mattress' ? 'Mattress' : 'Comfort');
        heading.textContent = `Choose Your ${label}`;
      }
    }

    function generateStars(rating) {
      let html = '';
      for (let i = 1; i <= 5; i++) {
        if (rating >= i) {
          html += '<span class="mb-modal__star mb-modal__star--filled">★</span>';
        } else if (rating > i - 1) {
          html += '<span class="mb-modal__star mb-modal__star--half">★</span>';
        } else {
          html += '<span class="mb-modal__star">★</span>';
        }
      }
      return html;
    }

    // ---------- SIZES ----------
    function populateSizes() {
      elements.sizeGrid.innerHTML = '';
      elements.sizeSection.style.display = 'block';

      const sizeDimensions = {
        'Twin': '38" × 75"',
        'Twin XL': '38" × 80"',
        'Full': '54" × 75"',
        'Queen': '60" × 80"',
        'King': '76" × 80"',
        'California King': '72" × 84"',
        'Cal King': '72" × 84"',
        'Cal-King': '72" × 84"',
        'Split King': '2x Twin XL',
        'Split-King': '2x Twin XL',
        'King Split-Support': 'King Top & Split-King Base'
      };

      state.currentProduct.sizes.forEach(size => {
        const sizeCard = document.createElement('div');
        sizeCard.className = 'mb-modal__size-option';
        sizeCard.dataset.size = size;

        const dimensions = sizeDimensions[size] || '';
        sizeCard.innerHTML = `
          <div class="mb-modal__size-name">${size}</div>
          ${dimensions ? `<div class="mb-modal__size-dimensions">${dimensions}</div>` : ''}
        `;
        sizeCard.addEventListener('click', () => selectSize(size));
        elements.sizeGrid.appendChild(sizeCard);
      });
    }

    // ---------- SECONDARY (Comfort/Firmness/Mattress) ----------
    function populateComforts() {
      const key = state.currentProduct.secondaryOptionKey;

      // No secondary option? hide section.
      if (!key || state.currentProduct.comforts.length === 0) {
        elements.comfortSection.style.display = 'none';
        return;
      }

      elements.comfortSection.style.display = 'block';
      elements.comfortGrid.innerHTML = '';

      // Update heading label each time in case product changes
      const heading = elements.comfortSection.querySelector('h4');
      if (heading) {
        const label = key === 'firmness' ? 'Firmness' : (key === 'mattress' ? 'Mattress' : 'Comfort');
        heading.textContent = `Choose Your ${label}`;
      }

      let optionsToShow = [];
      if (state.selectedSize) {
        optionsToShow = [
          ...new Set(
            state.currentProduct.variants
              .filter(v => v.size === state.selectedSize)
              .map(v => v[key])
              .filter(Boolean)
          )
        ];
      } else {
        optionsToShow = state.currentProduct.comforts;
      }

      optionsToShow.forEach(opt => {
        let variant = null;
        if (state.selectedSize) {
          variant = state.currentProduct.variants.find(v => v.size === state.selectedSize && v[key] === opt);
        }

        // Only show feel descriptor when secondary option is Comfort
        const feel = (key === 'comfort' && COMFORT_FEEL_MAP[opt]) ? COMFORT_FEEL_MAP[opt] : '';

        const card = document.createElement('div');
        card.className = 'mb-modal__comfort-option';
        card.dataset.comfort = opt;

        if (!state.selectedSize) {
          card.style.opacity = '0.5';
          card.style.cursor = 'not-allowed';
        } else {
          card.addEventListener('click', () => selectComfort(opt));
        }

        card.innerHTML = `
          <div class="mb-modal__comfort-name">${opt}</div>
          ${feel ? `<div class="mb-modal__comfort-feel">${feel}</div>` : ''}
          ${variant ? `<div class="mb-modal__comfort-price">${variant.price}</div>` : ''}
        `;

        elements.comfortGrid.appendChild(card);
      });
    }

    function selectSize(size) {
      elements.sizeGrid.querySelectorAll('.mb-modal__size-option').forEach(card => {
        card.classList.remove('mb-modal__size-option--selected');
      });

      const sizeCard = Array.from(elements.sizeGrid.querySelectorAll('.mb-modal__size-option'))
        .find(card => card.dataset.size === size);
      if (sizeCard) sizeCard.classList.add('mb-modal__size-option--selected');

      state.selectedSize = size;

      // refresh secondary options if present
      if (state.currentProduct.secondaryOptionKey) {
        state.selectedComfort = null;
        populateComforts();
      } else {
        // No secondary option: set matching variant for size
        const variant = state.currentProduct.variants.find(v => v.size === size);
        if (variant) state.selectedVariant = variant.id;
      }

      updateSummary();
      updateAddToCartButton();
    }

    function selectComfort(comfort) {
      if (!state.selectedSize) return;

      elements.comfortGrid.querySelectorAll('.mb-modal__comfort-option').forEach(card => {
        card.classList.remove('mb-modal__comfort-option--selected');
      });

      const comfortCard = Array.from(elements.comfortGrid.querySelectorAll('.mb-modal__comfort-option'))
        .find(card => card.dataset.comfort === comfort);
      if (comfortCard) comfortCard.classList.add('mb-modal__comfort-option--selected');

      state.selectedComfort = comfort;

      const key = state.currentProduct.secondaryOptionKey;
      const variant = state.currentProduct.variants.find(v =>
        v.size === state.selectedSize && v[key] === comfort
      );
      if (variant) state.selectedVariant = variant.id;

      updateSummary();
      updateAddToCartButton();
    }

    function updateSummary() {
      if (!state.currentProduct) return;

      let text = state.currentProduct.title;
      let price = '$0';

      if (state.selectedSize) {
        text += ` - ${state.selectedSize}`;
        
        if (state.currentProduct.comforts.length > 0 && state.currentProduct.secondaryOptionKey) {
          if (state.selectedComfort) {
            text += ` - ${state.selectedComfort}`;
            const key = state.currentProduct.secondaryOptionKey;
            const variant = state.currentProduct.variants.find(v => 
              v.size === state.selectedSize && v[key] === state.selectedComfort
            );
            if (variant) price = variant.price;
          } else {
            text += ' - Select option';
          }
        } else {
          const variant = state.currentProduct.variants.find(v => v.size === state.selectedSize);
          if (variant) price = variant.price;
        }
      } else {
        text += ' - Select size';
      }

      elements.summarySelection.textContent = text;
      elements.summaryTotal.textContent = price;
    }

    function updateAddToCartButton() {
      const canAddToCart =
        state.selectedSize &&
        (!state.currentProduct.secondaryOptionKey || state.selectedComfort);
      addToCartButton.disabled = !canAddToCart;
    }

    function handleAddToCart() {
      if (!state.selectedVariant) {
        alert('Please make your selection');
        return;
      }

      addToCartButton.classList.add('mb-modal__add-to-cart--loading');
      addToCartButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: state.selectedVariant, quantity: 1 }]
        })
      })
      .then(response => response.json())
      .then(data => {
        addToCartButton.classList.remove('mb-modal__add-to-cart--loading');
        addToCartButton.textContent = 'Added to Cart! ✓';
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        setTimeout(() => { window.location.href = '/cart'; }, 800);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        addToCartButton.classList.remove('mb-modal__add-to-cart--loading');
        addToCartButton.textContent = 'Error - Try Again';
        addToCartButton.disabled = false;
      });
    }

    function openModal() {
      modal.classList.add('mb-modal--active');
      document.body.classList.add('mb-modal-open');
      setTimeout(() => modal.classList.add('mb-modal--visible'), 10);
    }

    function closeModal() {
      modal.classList.remove('mb-modal--visible');
      setTimeout(() => {
        modal.classList.remove('mb-modal--active');
        document.body.classList.remove('mb-modal-open');
      }, 300);
    }

    function resetSelection() {
      state.selectedSize = null;
      state.selectedComfort = null;
      state.selectedVariant = null;

      elements.sizeGrid.querySelectorAll('.mb-modal__size-option').forEach(card => {
        card.classList.remove('mb-modal__size-option--selected');
      });

      if (elements.comfortGrid) {
        elements.comfortGrid.querySelectorAll('.mb-modal__comfort-option').forEach(card => {
          card.classList.remove('mb-modal__comfort-option--selected');
        });
      }

      addToCartButton.disabled = true;
      addToCartButton.classList.remove('mb-modal__add-to-cart--loading');
      addToCartButton.textContent = 'Add to Cart - Free 100-Night Trial';

      elements.summarySelection.textContent = 'Select a size';
      elements.summaryTotal.textContent = '$0';
    }
  }
})();
